import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Rect from '@bubble-ui/primitive-rect';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationRecycle = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationRecycle',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 101",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1393)",
    d: "M18.652 20.955h62.796v69.077c0 5.523-4.477 10-10 10H28.652c-5.523 0-10-4.477-10-10V20.955Z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 11.629,
    height: 55.819,
    x: 44.236,
    y: 32.584,
    fill: "url(#paint1_linear_5601_1393)",
    rx: 4
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 6.977,
    height: 55.819,
    x: 27.955,
    y: 32.584,
    fill: "url(#paint2_linear_5601_1393)",
    rx: 3.489
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 6.977,
    height: 55.819,
    x: 65.167,
    y: 32.584,
    fill: "url(#paint3_linear_5601_1393)",
    rx: 3.489
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_5601_1393)",
    d: "M18.652 20.955h62.797v4.652H18.652z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint5_linear_5601_1393)",
    d: "M14 15.652a4 4 0 0 1 4-4h64.1a4 4 0 0 1 4 4v3.303a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2v-3.303Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#BFAAFF",
    d: "M41.91 7h18.607l6.977 4.652h-32.56L41.91 7Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1393",
    x1: 14,
    x2: 86.1,
    y1: 20.955,
    y2: 100.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1393",
    x1: 50.051,
    x2: 50.051,
    y1: 32.584,
    y2: 88.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2B45C7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1393",
    x1: 31.444,
    x2: 31.444,
    y1: 32.584,
    y2: 88.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2B45C7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1393",
    x1: 68.656,
    x2: 68.656,
    y1: 32.584,
    y2: 88.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2B45C7"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_5601_1393",
    x1: 50.05,
    x2: 50.05,
    y1: 20.955,
    y2: 25.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint5_linear_5601_1393",
    x1: 50.05,
    x2: 50.05,
    y1: 11.652,
    y2: 20.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EBD4FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B8A6FF"
  }))));
};
ColoredIllustrationRecycle.displayName = 'ColoredIllustrationRecycle';
export default withProvisionalOverrideFromContext(ColoredIllustrationRecycle);
//# sourceMappingURL=index.js.map